<template>
  <div class="serviceDialog">
    <el-dialog :title="serviceDialogTitle" :visible.sync="show" @close="close" width="60%">
      <sirui-search
        ref="siruiSearch"
        :query="form"
        :columns="columns"
        :colSpan="8"
        :isQueryPanel="false"
        :rules="formRule"
        @resetBtnClick="resetBtnClick"
        @changeMethod="changeMethod"
      ></sirui-search>
      <div class="dialog-footer">
        <!-- <el-button  type="primary" @click="submitHandle">保存</el-button> -->
        <el-button @click="close">{{ $t('confirm.cancel') }}</el-button>
        <el-button type="primary" @click="submitHandle" v-if="action == 'add'">新增</el-button>
        <el-button type="primary" @click="saveHandle" v-if="action == 'edit'">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { producerColumns } from './index.js';
  import BASE_API from '@/api/dataBase';
  // import pinyin from 'pinyin';
  import goodsApi from '@/api/masterData/goods.js';
  import { pinyin } from 'pinyin-pro';

  export default {
    name: 'AddDialog',
    computed: {
      columns() {
        return producerColumns(this);
      },
      formRule() {
        return {
          companyCode: [{ required: true, message: '公司必填' }],
          departmentCode: [{ required: true, message: '部门必填' }],
          name: [{ required: true, message: '名称必填' }],
          productCategoryCode: [{ required: true, message: '商品分类必填' }],
        };
      },
    },
    data() {
      return {
        loading: false,
        form: {
          companyCode: null,
          companyName: null,
          departmentCode: null,
          departmentName: null,
          name: null,
          productCategoryCode: null,
          attrStatus: '1',
          unit: null,
          unitMass: null,
          packingGroup: null,
        },
        show: false,
        serviceDialogTitle: '新增属性',
        departmentList: [],
        companyList: [],
        attrType: '',
        productCategoryList: [],
        goodsClassifyList: [],
        goodsTypeList: [],
        action: '',
      };
    },
    mounted() {
      this.getCompanyList();
      this.getProduct();
      this.getGoodsParentApi();
      this.goodsClassifyList = this.dictListMap?.goods_type;
    },
    watch: {
      'form.name': {
        handler(val) {
          if (val) {
            this.form.pinyin = pinyin(val, { pattern: 'first', type: 'array' })?.join('');
          } else {
            this.form.pinyin = '';
          }
        },
      },
    },
    methods: {
      openDialog(action, attrType, attrId) {
        this.show = true;
        this.action = action;
        if (action == 'add') {
          this.serviceDialogTitle = '新增属性';
        } else {
          this.serviceDialogTitle = '编辑属性';
          this.getDetail(attrId);
        }
        this.attrType = attrType;
      },
      close() {
        console.log('关闭窗口');
        this.show = false;
        this.resetBtnClick();
        this.$emit('update');
      },
      async changeMethod({ val, prop }) {
        console.log(val, prop);
        if (prop == 'companyCode') {
          this.form.companyCode = val;
          this.form.companyName = this.companyList.find((item) => item.value == val)?.label;
          this.department(val);
        } else if (prop == 'departmentCode') {
          this.form.departmentCode = val;
          this.form.departmentName = this.departmentList.find(
            (item) => item.personDepartmentCode == val
          )?.personDepartmentName;
        } else if (prop == 'productCategoryCode') {
          this.form.productCategoryCode = val;
          this.form.productCategoryName = this.productCategoryList.find(
            (item) => item.value == val
          )?.label;
          this.form.productCategoryId = this.productCategoryList.find(
            (item) => item.value == val
          )?.id;
          this.getGoodsParentApi();
        }
        // else if (prop == 'name') {
        //   if (this.form.name) {
        //     this.form = {
        //       ...this.form,
        //       pinyin: pinyin(this.form.name, { pattern: 'first', type: 'array' })?.join(''),
        //     };
        //   } else {
        //     this.form.pinyin = null;
        //   }
        // }
      },
      // 新增
      async submitHandle() {
        let postData = await this.getValidateFormData();
        if (postData) {
          this.loading = true;
          let result = await this.$axios.post(goodsApi.GOODS_ATTR_ADD, postData);
          console.log('reuslt', result);
          if (result.data.code == 0) {
            this.$message.success(result.data.msg);
            this.loading = false;
            this.show = false;
          } else {
            this.$message.error(result.data.msg);
            this.loading = false;
          }
        }
      },
      // 编辑(与新增同一个接口，后端根据有无id区分)
      async saveHandle() {
        this.submitHandle();
      },
      // 获取详情
      async getDetail(id) {
        let { data } = await this.$axios.get(`${goodsApi.GOODS_ATTR_DETAIL}/${id}`);
        if (data.code == 0) {
          let formData = data.data;
          this.form = {
            ...formData,
            attrStatus: formData.attrStatus ? String(formData.attrStatus) : '',
            isModelCalculate: formData.isModelCalculate ? String(formData.isModelCalculate) : '',
            productId: formData.productId ? String(formData.productId) : '',
          };
        } else {
          this.$message.error(data.msg);
        }
      },
      async getCompanyList() {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          // personCompanyCode: this.userInfo.companyCode,
        };
        const res = await this.$axios.post(BASE_API.GET_PERSON_API, params);
        // console.log(res.data.data.personDepartmentInfo,'personDepartmentInfo');
        this.companyList = res.data.data?.personCompanyInfo.map((item) => {
          return {
            ...item,
            value: item.personCompanyCode,
            label: item.personCompanyName,
          };
        });
        if (this.form.companyCode) {
          this.department(this.form.companyCode);
        }
      },
      async getValidateFormData() {
        return new Promise((resolve) => {
          this.$refs.siruiSearch.validate((valid) => {
            if (valid) {
              let postData = {
                ...this.form,
                attrType: this.attrType,
                productId: this.form.productId ? +this.form.productId : '',
                productChName: this.goodsTypeList.find((item) => item.value == this.form.productId)
                  ?.label,
                goodsClassify: this.goodsClassifyList.find(
                  (item) => item.value == this.form.goodsClassifyCode
                )?.label,
              };
              resolve(postData);
            } else {
              resolve(null);
              this.$message.error('请检查数据填写');
            }
          });
        });
      },
      // 获取商品名称数据
      async getGoodsParentApi() {
        let groupCategory = this.form.productCategoryCode;
        let groupCategoryName = this.form.productCategoryName;
        console.log('查询商品名称信息', groupCategory, groupCategoryName);
        const { data } = await this.$axios.post(goodsApi.PRODUCT_TYPE, {
          parentProductStatus: 'ZT03',
          selectCompanyCode: this.userInfo.companyCode,
          adminFlag: this.userInfo.adminFlag,
          groupCategory,
          groupCategoryName,
        });
        if (data.code == 0) {
          this.goodsTypeList = data.data?.map((item) => {
            return {
              ...item,
              value: item.id,
              label: item.productChName,
            };
          });
          console.log(data.data, '商品大类数据');
        } else {
          console.error('获取商品大类数据失败');
        }
      },
      resetBtnClick() {
        this.$refs.siruiSearch.$refs['queryFrom'].resetFields();
        this.form = {
          companyCode: null,
          companyName: null,
          departmentCode: null,
          departmentName: null,
          name: null,
          productCategoryCode: null,
          attrStatus: '1',
          unit: null,
          unitMass: null,
          packingGroup: null,
        };
      },
      // 获取部门
      department(contractCompanyNo) {
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: contractCompanyNo,
        };
        this.$axios.post(BASE_API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data.personDepartmentInfo || [];
            if (this.departmentList.length)
              this.departmentList = this.departmentList.map((item) => {
                return {
                  ...item,
                  value: item.personDepartmentCode,
                  label: item.personDepartmentName,
                };
              });
            console.log('获取部门', this.departmentList);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 获取商品分类
      getProduct() {
        // this.$axios.get(BASE_API.GOOD_ATTR_TYPE, {});
        this.$axios.post(goodsApi.GOOD_ATTR_TYPE, {}).then((res) => {
          console.log('res', res);
          if (res.data.code === 0) {
            this.productCategoryList = res.data.data || [];
            if (this.productCategoryList.length)
              this.productCategoryList = this.productCategoryList.map((item) => {
                return {
                  ...item,
                  value: item.categoryCode,
                  label: item.categoryName,
                };
              });
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  .dialog-footer {
    text-align: center;
  }
  .expenses-box {
    margin-bottom: 30px;
    .expenses-title {
      height: 40px;
      line-height: 40px;
      margin-bottom: 15px;
    }
  }
</style>
